import React from 'react'
import axios from 'axios';
import TopBar from '../TopBar/TopBar'
import About from '../About/About'
import Cards from '../Cards/Cards'
import LogoShow from '../LogoShow/LogoShow'
import { useParams } from "react-router-dom";
import './CommunityCatalog.css';
function CommunityCatalog() {
    const { idClub } = useParams();

    console.log(idClub);
    // Define all API endpoints for multiple brands in club
    const apiGetData = {
        club : `https://api.mybenefitz.com/admin/club/${idClub}`,
        clubBusinessMember : `https://api.mybenefitz.com/admin/club/${idClub}/clubBusinessMembers`,
    };

    
    return (
        <div className="page-container">
            <div className="content">
                <TopBar apiClubData={apiGetData.club} />
                <About />
                <Cards apiClubData={apiGetData} />
            </div >
            <div className="logoShow">
                <LogoShow />
            </div>
        </div>
    );
}

export default CommunityCatalog;